'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { Component } = React;
const sanitizeHtml = require('sanitize-html');
const HtmlEntities = require('html-entities').AllHtmlEntities;

const DEFAULT_ALLOWED_TAGS = ['br', 'a'];
const DEFAULT_ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title'],
};

/**
 * Sanitizes user input HTML. See documentation for `sanitize-html` for more infotmation.
 * Also allows optionally decoding HTML entities.
 */
class SanitizeHtml extends Component {
    render() {
        const { content, decodeEntities, allowedTags, allowedAttributes, ...other } = this.props;
        let _content = String(content);

        if (decodeEntities) {
            _content = new HtmlEntities().decode(content);
        }

        // assign this._content for testing purposes only
        this._content = _content = sanitizeHtml(_content, {
            allowedTags: allowedTags,
            allowedAttributes: allowedAttributes,
        });

        return <span {...other} dangerouslySetInnerHTML={{ __html: _content }} />;
    }
}

SanitizeHtml.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    decodeEntities: PropTypes.bool,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    allowedTags: PropTypes.arrayOf(PropTypes.string),
    allowedAttributes: PropTypes.object,
};

SanitizeHtml.defaultProps = {
    decodeEntities: false,
    content: '',
    allowedTags: DEFAULT_ALLOWED_TAGS,
    allowedAttributes: DEFAULT_ALLOWED_ATTRIBUTES,
};

module.exports = SanitizeHtml;



// WEBPACK FOOTER //
// ./assets/js/global/components/SanitizeHtml.jsx